import { alpha, Box, Button, IconButton, Stack, styled } from "@mui/material";
import AvatarMenu from "./AvatarMenu";
import QuickActions from "./QuickActions";
import { Menu, Wallet } from "@mui/icons-material";
import AddWalletModal from "../modals/AddWalletModal";
import { useEffect, useState } from "react";
import { api } from "../../config/api";

import { useNavigate } from "react-router-dom";


interface Props {
  showSidebar: "true" | "false";
  setWidth: React.Dispatch<React.SetStateAction<string>>;
}

declare global {
  interface Window {
    Razorpay: any;
  }
}

const TopBar = ({ showSidebar, setWidth }: Props) => {
  const [walletOpen, setWalletOpen] = useState(false);
const navigate = useNavigate()
  const [walletBalance, setWalletBalance] = useState(0);

  useEffect(() => {
    if (walletOpen === false) {
      api
        .get("/payment/amountInWallet/")
        .then((data) => {
          setWalletBalance(data?.data?.data ?? 0);
        })
        .catch((error) => {
          console.log("Wallet Error", error);
          setWalletBalance(0);
        });
    }
  }, [walletOpen]);

  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: "60px",
        top: 0,
        // backgroundColor: "#37bc9b ",
        backgroundColor: "#217aee ",
        boxShadow: "1px 2px 7px 0px rgba(0, 0, 0, 0.334)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
          gap: "30px",
          marginRight: "14px",
          marginLeft: `${showSidebar === "true" ? "80px" : "4px"}`,
        }}
      >
        <div>
          {showSidebar === "false" && (
            <Button onClick={() => setWidth("300px")}>
              <Menu />
            </Button>
          )}
        </div>
        <Stack direction={"row"} gap={"30px"}>
     
          <Button
            onClick={() => setWalletOpen(true)}
            sx={{
              display: "flex",
              gap: "10px",
            }}
          >
            <Wallet
              sx={{
                color: "#fff",
              }}
            />
            <p
              style={{
                color: "#fff",
              }}
            >
              Rs.{walletBalance}
            </p>
          </Button>
          <QuickActions />
          <AvatarMenu />
        </Stack>
      </Box>
      <AddWalletModal
        open={walletOpen}
        handleClose={() => setWalletOpen(false)}
      />
    </div>
  );
};

export default TopBar;
